<template>
    <div class="templete_box">
        <div class="crumbsNav clearfix no_print">
            <div class="navSon navSonChecked" v-if="categoryBoardType">
                板材销售
            </div>
            <div class="navSon" v-if="categoryRawType">
                原木销售
            </div>
        </div>
        <div class="templete no_print">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.salesman_id" placeholder="销售人" @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                <el-select class="search_select search_inputBox" v-model="params.search.status" multiple collapse-tags placeholder="订单状态" @visible-change="getSelectList('options')">
                    <el-option v-for="list in selectMap.options" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.truck_remark" placeholder="车牌"></el-input>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="sousuoBtn" @click="openSou"></div>
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn" v-if="module.includes(',sell-order-edit,')" @click="dialogVisible=true;orderType=1;detailInfo={}">新建销售单</el-button>
                <!-- <el-button class="funcPublicBtn" v-if="module.includes(',sell-order-edit,')">生成销售明细</el-button> -->
                <el-button class="funcPublicBtn" v-if="module.includes(',sell-order-edit,')" @click="batchDel">批量删除</el-button>
                <el-button class="funcPublicBtn" v-if="module.includes(',sell-order-edit,')" @click="batchBack">批量撤回</el-button>
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.includes(',sell-order-edit,') && !module.includes(',sell-order-disable-submit,')" @click="batchExamine">提交销售审核</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="order.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @isCancel="isCancels" @backClick="backClick" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @getTransfer="getTransfer" @rowClick="rowClick"  @sortTable="sortList"></tabletem>
            </div>
            <div class="totalCal">
                <!-- <div class="totalNumber">选中立方： {{total_select}}</div> -->
                <div class="totalNumber">合计件数： {{totalObj.count}}</div>
                <div class="totalNumber">合计立方： {{totalObj.total_cube}}</div>
                <div class="totalNumber">合计金额： {{totalObj.total_amount}}</div>
                <div class="totalNumber"></div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <sale-bill-base ref="saleBillBase" :dialog="dialogVisible" @hide="dialogVisible=false" :dt="orderType"
        :form-data="detailInfo" :scene="'order.create.column'">
            <div class="editBtnList clearfix">
                <div style="float:left;margin-bottom: 10px;">
                    <el-button class="funcPublicBtnEdit" style="line-height: 25px;" v-if="orderType===1||detailInfo.saleOrderIsEdit&&module.includes('order-fee-add')&&!(detailInfo.status==5||detailInfo.status==6||detailInfo.status==7)" @click="openbusinessRelation">关联销售费用</el-button>
                    <el-select class="funcPublicBtn"  v-model="print_tpl_id" style="line-height: 25px;"  @visible-change="getSelectList('saleTemplate',$event)" @change="changePrint_id()">
                        <el-option v-for="list in selectMap.saleTemplate" :key="list.id" :value="list.id" :label="list.name"></el-option>
                    </el-select>
                    <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                        <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                            {{list.fee_name+':  ￥'+list.amount}}
                            <img src="../../assets/top-delete-suspension.png" v-if="!detailInfo.id" class="newFeeImg" @click="delOutFee(index)"/>
                            <img src="../../assets/top-delete-suspension.png" v-else-if="detailInfo.isDeleteFee==1" class="newFeeImg" @click="isDeleteFee(list.id)"/>
                        </div>
                    </div>
                </div>
                <div class="editBtn" style="margin-bottom: 10px;">
                    <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="detailInfo.saleOrderIsSuperEdit" @click="superModify(detailInfo.id)">超级修改</el-button>
                    <el-button class="funcPublicBtn" v-if="detailInfo.id&&module.includes(',sell-print-africa-inventory,')" @click="printOrnginal">码单打印</el-button>
                    <el-button class="funcPublicBtn" v-if="detailInfo.id" @click="print(8)">合同打印</el-button>
                    <el-button class="funcPublicBtn" v-if="detailInfo.id&&module.includes(',sell-order-print,')" @click="print(0)">打印</el-button>
                    <el-button class="funcPublicBtn" v-if="detailInfo.id&&module.includes(',sell-order-export,')" @click="exportExcelBill">导出</el-button>
                    <el-button class="funcPublicBtn" v-if="orderType===1||detailInfo.saleOrderIsEdit" @click="save(0)">锁定保存</el-button>
                    <el-button class="funcPublicBtn funcPublicBtnChecked" style="width:110px;" v-if="orderType===1||detailInfo.saleOrderIsEdit && !module.includes(',sell-order-disable-submit,')" @click="save(1)">保存并提交审核</el-button>
                    <el-button class="funcPublicBtn" v-if="detailInfo.saleOrderIsCancel" @click="isCancel(detailInfo.id)">撤回</el-button>
                </div>
            </div>
        </sale-bill-base>
        <!-- dialog END -->
        <!-- dialog START -->
        <saleCheckout ref="saleCheckout" :dialog="checkoutDialogVisible" @hide="checkoutDialogVisible=false" :dt="orderType"
        :form-data="detailInfo" :scene="'order.create.column'">
            <div class="editBtnList clearfix">
                <div style="float:left;margin-bottom: 10px;">
                    <el-button class="funcPublicBtnEdit" style="line-height: 25px;" v-if=" module.includes('order-fee-add')&&!(detailInfo.status==5||detailInfo.status==6||detailInfo.status==7)" @click="openbusinessRelation">关联销售费用</el-button>
                    <el-select class="funcPublicBtn"  v-model="print_tpl_id" style="line-height: 25px;"  @visible-change="getSelectList('saleTemplate',$event)">
                        <el-option v-for="list in selectMap.saleTemplate" :key="list.id" :value="list.id" :label="list.name"></el-option>
                    </el-select>
                    <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                        <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                            {{list.fee_name+':  ￥'+list.amount}}
                            <img src="../../assets/top-delete-suspension.png" v-if="!detailInfo.id" class="newFeeImg" @click="delOutFee(index)"/>
                            <img src="../../assets/top-delete-suspension.png" v-else-if="detailInfo.isDeleteFee==1" class="newFeeImg" @click="isDeleteFee(list.id)"/>
                        </div>
                    </div>
                </div>
                <div class="editBtn" style="margin-bottom: 10px;">
                    <el-button class="funcPublicBtn funcPublicBtnChecked" style="width:110px;" @click="checkout()">确认修改</el-button>
                </div>
            </div>
        </saleCheckout>
        <!-- dialog END -->

        <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加营业外支出费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                     <el-form-item  label="销售单号：" v-if="detailInfo.id">
                        <el-input v-model="businessRelationForm.order_sn" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="detailInfo.id" @click="saveOutFee">确认</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-else @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
        <!--拒绝原因START-->
        <el-dialog v-dialog-drag title="拒绝原因" :visible.sync="centerDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
            <textarea class="edit_input edit_textarea" v-model="refuse_remark" placeholder="请输入拒绝原因" readonly></textarea>
		</el-dialog>
        <!--拒绝原因END-->

        <!--弹框确认提交审核是否同步销售日期和审核日期为同一天-->
        <el-dialog v-dialog-drag :title="isShowDiffDateCheckBox?'是否确定提交审核?':'提示'" :visible.sync="submitConfirmDialog" width="380px" class="eldialog cDiaC" :model="false">
            <el-checkbox v-model="is_current_time " v-if="isShowDiffDateCheckBox"
                         class="confirmCheckBox">锁定销售日期和提交审核日期不是同一天，是否要将销售日期变更为提交销售审核日期为准？
            </el-checkbox>
            <span v-if="!isShowDiffDateCheckBox" class="confirmSpan">是否确定提交审核？</span>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="confirmSubmit">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="submitConfirmDialog=false">取消</el-button>
            </div>
        </el-dialog>
        <!--弹框确认提交审核是否同步销售日期和审核日期为同一天-->
        <el-dialog v-dialog-drag :title="isShowDiffDateCheckBox?'是否确定删除?':'提示'" :visible.sync="transferOrderDialog" width="380px" class="eldialog cDiaC" :model="false">
            <el-checkbox v-model="tran_action" v-if="isShowDiffDateCheckBox"
                         class="transferConfirmCheckBox">销售单含有调货在途资源，勾选同步删除?
            </el-checkbox>
            <span v-if="!isShowDiffDateCheckBox" class="confirmSpan">是否确定提交审核？</span>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="deleteTran_action">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="transferOrderDialog=false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 搜索弹框 -->
        <el-dialog title="客户搜索" :visible.sync="customerDialogVisibles" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="customerCloses" v-dialogDrag>
            <div style="padding:10px;">
                <el-input placeholder="请输入客户名称" maxlength=100 v-model="params.search.customer_name"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="Customerion()">确认</el-button>
            </span>
        </el-dialog>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="order.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue';
    import pagination from '../../components/pagination.vue';
    import selectDownCustomer from '../../components/selectDownCustomer.vue';
    import saleBillBase from '../../components/saleBillBase.vue';
    import saleCheckout from './saleCheckout.vue';
    const initBusinessRelationForm = {
        order_id: "",
        order_sn: "",
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    const initSearchParams = {
        search: {
            order_sn: "",
            sales_time: "",
            start_time: "",
            end_time: "",
            customer_id: "",
            salesman_id: "",
            status: "",
            customer_name:"",
            truck_remark:""
        },
        page: 1,
        per_page: 50
    };
    const initTotalObj = {
        total_amount: "",
        total_cube: "",
        total_select: 0,
        count: 0
    };
    export default {
        data() {
            return {
                detailInfo: {},
                totalObj: this.$cloneJson(initTotalObj),
                is_current_time: true,//是否使用当前时间 （0否 1是）
                isShowDiffDateCheckBox: true,//是否显示checkbox
                submitConfirmDialog: false,//对话框
                transferOrderDialog: false,//删除时，调货数据提示框
                submitConfirmType: '',//确认提交类型
                batchSubIds: [],
                transferId:'',//删除有调货数据的id
                tran_action:true,
                tableLoading: false,
                module: localStorage.dw_erp_power_code,

                boardAmericaType: localStorage.dw_erp_board.includes("board-america"),
                boardAfricaType: localStorage.dw_erp_board.includes("board-africa"),
                categoryRawType: localStorage.dw_erp_category.includes("raw"),
                categoryBoardType: localStorage.dw_erp_category.includes("board"),

                filter: [],
                printCustomer: "",
                printSale: "",
                companyName: localStorage.dw_erp_company_name,
                businessRelation: false,
                outFeeSelect: [],
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                feeOutFormRlues: {
                    fee_date: [{required: true, message: '请填写日期', trigger: 'blur'}],
                    order_id: [{required: true, message: '请选择销售单号', trigger: 'blur'}],
                    fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                    payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                    amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                    is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
                },
                newFee: [],
                print_tpl_id:0,
                start_time: "",
                end_time: new Date(),
                sales_time: new Date(),
                delivery_time: new Date(),
                predict_time: new Date(),
                params: this.$cloneJson(initSearchParams),
                listType: "",

                dialogVisible: false,//
                checkoutDialogVisible: false,//部分等待出库销售单据
                filterDialogVisible:false,
                filter:"",
                fields:"",
                centerDialogVisible: false,
                dialogVisibleCustomer: false,
                relationObj: {},
                refuse_remark: "",
                last_page: 1,
                total: 0,
                selectRow: [],
                customerList: [],
                customerListT: [],
                saleManList: [],
                paymenttypeList: [],
                accountList: [],
                selectMap: {
                    user: [],
                    options:[],
                    saleTemplate:[]
                },
                list: [],
                tableCol: [
                    {colName:"销售日期",colKey:"sales_time",isDate:true,colWidth:90,isCanClick:false,backClick:false},
                    {colName:"销售单号",colKey:"order_sn",colWidth:190,isCanClick:true,backClick:false,isShow:true,isSort:true},
                    {colName:"订单状态",colKey:"status_text",colWidth:100,isCanClick:false,backClick:true,isColor:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isCanClick:false,backClick:false},
                    {colName:"件数",colKey:"count",colWidth:50,isCanClick:false,backClick:false},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:100,isCanClick:false,backClick:false},
                    {colName:"销售人",colKey:"salesman_name",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"审核人",colKey:"auditor_name",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"制单人",colKey:"creator_name",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"收结状态",colKey:"already_amount",colWidth:100,isCanClick:false,isColor:true,},
                    {colName:"备注",colKey:"remark",colWidth:150,isCanClick:false,backClick:false},
                    {colName:"订单来源",colKey:"order_source_text",colWidth:75,isCanClick:false,backClick:false},
                    {colName:"锁定等级",colKey:"lock_level",colWidth:100,isCanClick:false,isColor:true,islockLevel:true},
                    {colName:"提货车牌",colKey:"truck_remark",colWidth:100,isCanClick:false},
                    ],

                total_select: 0,
                orderType: 1,//1新增 2修改 3详情
                orderId:0,
                refreshSale:{},//刷新销售单弹框
                addId:0,
                customerDialogVisibles:false,

            };
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.getSelectList("saleTemplate");
        },
        methods:{
            superModify(id){
                // this.checkoutDialogVisible=true;
                this.dialogVisible=false;
                this.oncheckout(id);
            },
            printOrnginal(){
                let url = "/saleOriginalPrint?id=" + this.detailInfo.id;
                window.open(url);
            },
            isCancel(id){
                let ids = new Array();
                ids.push(id)
                this.$confirm('是否确定撤回?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/order.cancel",{ids:ids.toString()},()=>{
                        this.tip("撤回成功","success")
                        this.dialogVisible = false;
                        this.getList();
                        this.rowClick(this.refreshSale)
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            isCancels(id){
                let ids = new Array();
                ids.push(id)
                this.$confirm('是否确定撤回?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/order.cancel",{ids:ids.toString()},()=>{
                        this.tip("撤回成功","success")
                        this.dialogVisible = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            isDeleteFee(id){
                if(id){
                    id=id
                }else{
                    id=Number(this.addId)
                }
                this.postFunc("/erp/order.delete.fee",{fee_id:id},()=>{
                    this.dialogVisible = false;
                        this.tip("删除成功","success")
                        this.rowClick(this.refreshSale)
                })
            },
            delOutFee(ind){
                this.newFee.forEach((item,index)=>{
                    if(index==ind){
                        this.newFee.splice(index,1)
                    }
                })
            },
            outFeeChange(e){
                this.outFeeSelect.forEach(item=>{
                    if(item.id==e){
                        this.businessRelationForm.fee_name = item.name;
                    }
                })
            },
            newOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]==""){
                        if(key=="order_id"||key=="order_sn"||key=="remark"){
                            this.pl(key)
                        }else{
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                // let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.newFee.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                this.businessRelation=!this.businessRelation;
            },
            openbusinessRelation(){
                this.businessRelationForm.order_id = this.detailInfo.id;
                this.businessRelationForm.order_sn = this.detailInfo.order_sn;
                this.businessRelation = true;
                this.businessRelationForm.fee_date = this.sales_time;
            },
            saveOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]===""){
                        if(key!="remark"){
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                this.save(0,'',true)
                let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.postFuncLoading("/erp/order.add.fee",this.businessRelationForm,res=>{
                    this.addId=res.data.data.id
                    this.businessRelation=!this.businessRelation;
                    this.tip("添加成功", "success");
                    this.newFee.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                },error=>{
                    this.businessRelationForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            //获取费用名称
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{type:2},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            exportExcelBill(){
                this.$exportExecl("/erp/order.export","销售单",{id:this.detailInfo.id,"scene":"order.create.column"})
            },

            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            print(category){
                let url = "/saleOrderPrint?id=" + this.detailInfo.id + "&category=" + category;
                window.open(url);
            },
             //订单撤回START
            batchBack(){
                if(this.selectRow.length<1){
                    this.tip("请选择订单","warning")
                }else{
                    let flag = true;
                    let arr = [];
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isCancel){
                            flag = false;
                            this.tip("选择订单中有不可撤销项","warning")
                            return;
                        }else{
                            arr.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.Back(arr)
                    }
                }
            },
            Back(ids){
                this.$confirm('是否确认撤销?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/order.cancel",{ids:ids.toString()},()=>{
                        this.tip('撤销成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //订单撤回END

            //订单提交审核START
            batchExamine(){
                if(this.selectRow.length<1){
                    this.tip("请选择订单","warning")
                }else{
                    let isValid = this.selectRow.every(a => a['isReqReview']);
                    if (!isValid) {
                        this.tip("选择订单中有不可提交审核项", "warning");return;
                    }
                    this.batchSubIds = this.selectRow.map(d => d.id);
                    //查询是否含有今天之前的销售日期
                    let hasBeforeDays = this.$isHasBeforeDays(this.selectRow, 'sales_time');
                    if (hasBeforeDays) {
                        this.isShowDiffDateCheckBox = true;
                        this.is_current_time = true;//默认勾选
                    }else{
                        this.isShowDiffDateCheckBox = false;
                        this.is_current_time = false;//不勾选
                    }
                    this.submitConfirmDialog = true;
                    this.submitConfirmType = 'batchSubmit';//批量提交
                }
            },
            confirmSubmit() {
                if (this.submitConfirmType === 'batchSubmit') {
                    let ids = this.batchSubIds;
                    this.postFuncLoading("/erp/order.req.review", {
                        ids: ids.toString(),
                        is_current_time: Number(this.is_current_time)
                    }, () => {
                        this.submitConfirmDialog = false;
                        this.tip('提交审核成功', 'success');
                        this.getList();
                    }, error => {
                        this.tip(error.data.message, "warning");
                    });
                }else if (this.submitConfirmType === 'dialogSubmit') {
                    this.save(1, true);
                }

            },
            //订单提交审核END
            //订单删除调货数据确定
            deleteTran_action(){
                this.postFuncLoading("/erp/order.delete",{ids:this.transferId,tran_action:Number(this.tran_action)},()=>{
                    this.tip('删除成功','success');
                    this.transferOrderDialog=false;
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //订单删除START
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择订单","warning")
                }else{
                    let flag = true;
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isDelete){
                            flag = false;
                            this.tip("选择订单中有不可删除项","warning")
                            return;
                        }else{
                            arr.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.del(arr,'')
                    }
                }
            },
            del(ids,obj){
                if(obj.is_transfer==1){
                    this.transferOrderDialog=true;
                    this.transferId=[obj.id]
                }else{
                    this.confirmLog("是否确认删除?",()=>{
                        this.postFuncLoading("/erp/order.delete",{ids:ids.toString()},()=>{
                            this.tip('删除成功','success');
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    });
                }
            },
            //订单删除END

            //保存，修改
            save(type, skipCheck = false,isAssociation) {
                let $baseRef = this.$refs.saleBillBase;
                $baseRef.$refs["saleorderA"].validate((valid) => {
                    if (valid) {
                        $baseRef.$refs["saleorderB"].validate((validC) => {
                            let tran_action = this.$cloneJson($baseRef.tran_action);
                            let _params = this.$cloneJson($baseRef.form_params);
                            let _listDetail = this.$cloneJson($baseRef.listDetail);
                            if(_params.rec_type==2){
                                _params.rec_type = 'DIV'
                            }else{
                                _params.rec_type = 'MUL'
                            }
                            if (validC) {
                                let url = "";
                                if (this.orderType === 1) {
                                    url = "/erp/order.create";
                                    _params.fee_list = this.newFee;
                                    _params.print_tpl_id = this.print_tpl_id;
                                } else {
                                    _params.print_tpl_id = this.print_tpl_id;
                                    url = "/erp/order.update";
                                }
                                _params.tran_action = tran_action ? 1 : 0;
                                _params.rec = _params.rec ? 1 : 0;
                                _params.is_show_traffic = _params.is_show_traffic ? 1 : 0;
                                _params.is_discount_rate = _params.is_discount_rate ? 0 : 0;
                                _params = this.$changeTimeParams(_params, ['sales_time', 'predict_time', 'delivery_time']);
                                let inventory_list = [];
                                let cloud_list = [];
                                _listDetail.forEach(item => {
                                    if (item.inventory_cloud_id) {
                                        cloud_list.push(item)
                                    } else {
                                        inventory_list.push(item)
                                    }
                                });
                                _params.inventory_list = inventory_list;
                                _params.cloud_list = cloud_list;
                                _params.is_request_review = type;
                                if (Number(type) === 1) {
                                    if (skipCheck) {
                                        //跳过检查
                                        _params.is_current_time = Number(this.is_current_time);
                                    }else {
                                        //提交审核时才提示弹框，仅保存时不提示
                                        let hasBeforeDays = this.$isHasBeforeDays([_params], 'sales_time');
                                        if (hasBeforeDays) {
                                            this.submitConfirmType = 'dialogSubmit';
                                            this.isShowDiffDateCheckBox = true;
                                            this.is_current_time = true;//默认勾选
                                            this.submitConfirmDialog = true;
                                            return;
                                        }
                                    }
                                }
                                this.postFuncLoading(url, _params, () => {
                                    this.submitConfirmDialog = false;
                                    if(isAssociation){
                                        this.rowClick(this.refreshSale)
                                    }else{
                                        this.dialogVisible = false;
                                        this.tip('操作成功', 'success');
                                        this.getList();
                                    }
                                }, error => {
                                    this.tip(error.data.message, "warning")
                                })
                            } else {
                                return false;
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            checkout(){
                let $baseRef = this.$refs.saleCheckout;
                let _params = this.$cloneJson($baseRef.form_params);
                let _listDetail = this.$cloneJson($baseRef.listDetail);
                // let arrnew = _listDetail.map((item,index) => {
                //     return Object.assign({},{'id':item.id,"inventory_id":item.inventory_id,'sales_width':item.sales_width,"sales_cube":item.sales_cube,"sales_price":item.sales_price,"status":item.status})
                // })
                this.postFuncLoading('/erp/order.modify',{id:_params.id,inventory_list:_listDetail},res=>{
                    this.checkoutDialogVisible=false;
                    this.tip('操作成功', 'success');
                    this.getList();
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            getRow(row){
                this.selectRow=row;
            },
            reset(){
                this.start_time="";
                this.end_time = new Date();
                this.$refs['selectdowncustomer'].clearData();
                this.params = this.$cloneJson(initSearchParams);
                this.getList();
            },
            filterConfirm(){
                this.getList()
            },
            openSou(){
                this.customerDialogVisibles = true
            },
            customerCloses(){
                this.customerDialogVisibles = false;
            },
            Customerion(){
                this.getList();
                this.customerDialogVisibles = false;
                this.params.search.customer_name = '';
            },
            getList(flag){
                if(flag)this.params.page = 1;
                let searchKey=this.$cloneJson(this.params);
                searchKey.search.start_time = this.formatTimeZero(this.start_time);
                searchKey.search.end_time = this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/order.list",searchKey,res=>{
                    this.filter = res.data.data.column;
                    let resD = res.data.data;
                    this.last_page=parseInt(resD.last_page);
                    this.params.page=parseInt(resD.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(resD.total);
                    this.totalObj=this.$cloneJson(resD.statistics);
                    this.list=this.$cloneJson(resD.list);
                    this.list.forEach((item,index)=>{
                        item.baseColor = "";
                        if(item.status==2){
                            item.baseColor="#B400FF";
                        }else if(item.status==3){
                            item.baseColor="#155BD4";
                        }else if(item.status==4){
                            item.baseColor="#B400FF";
                        }else if(item.status==5){
                            item.baseColor="#007B04";
                        }else if(item.status==6){
                            item.baseColor="#007B04";
                        }else if(item.status==1){
                            item.baseColor="#FF0000";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            backClick(id){
                this.list.forEach(item=>{
                    if(id==item.id){
                        this.centerDialogVisible=true;
                        this.refuse_remark=item.refuse_remark;
                    }
                })
            },
            rowClick(obj){
                let total_number = 0;
                this.orderId =obj.id;
                this.refreshSale = obj;
                this.postFuncLoading("/erp/order.order", {id: obj.id}, res => {
                    let resD = res.data.data;
                    this.orderType = resD.isEdit ? 2 : 3;
                    res.data.data.relate_list.forEach(item =>{
                        if(item.rec == 1){
                            total_number += Number(item.amount);
                        }
                    })
                    resD.tax_rec_amount = total_number;
                    if(resD.rec_type=='DIV'){
                        resD.rec_type = 2
                    }else{
                        resD.rec_type = 1
                    }
                    this.newFee = resD.fee_list;
                    this.detailInfo = resD;
                    this.detailInfo.saleOrderIsEdit = !!resD.isEdit;
                    this.detailInfo.saleOrderIsCancel = !!resD.isCancel;
                    this.detailInfo.saleOrderIsSuperEdit = !!resD.isSuperEdit;
                    this.print_tpl_id = res.data.data.print_tpl_id;
                    this.dialogVisible = true;
                }, error => {
                    this.tip(error.data.message, "warning")
                });
            },
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            //打开部分和等待出库单据
            oncheckout(id){
                let total_number = 0;
                this.postFuncLoading("/erp/order.order", {id: id}, res => {
                    let resD = res.data.data;
                    this.orderType = resD.isEdit ? 2 : 3;
                    res.data.data.relate_list.forEach(item =>{
                        if(item.rec == 1){
                            total_number += Number(item.amount);
                        }
                    })
                    resD.tax_rec_amount = total_number;
                    if(resD.rec_type=='DIV'){
                        resD.rec_type = 2
                    }else{
                        resD.rec_type = 1
                    }
                    this.newFee = resD.fee_list;
                    this.detailInfo = resD;
                    this.detailInfo.saleOrderIsEdit = !!resD.isEdit;
                    this.detailInfo.saleOrderIsCancel = !!resD.isCancel;
                    this.detailInfo.saleOrderIsSuperEdit = !!resD.isSuperEdit;
                    this.print_tpl_id = res.data.data.print_tpl_id;
                    this.checkoutDialogVisible = true;
                }, error => {
                    this.tip(error.data.message, "warning")
                });
            },
            //选中模板
            changePrint_id(){
                if(this.detailInfo.id&&this.module.includes(',sell-order-print,')){
                    this.postFunc('erp/order.template.update',{id:this.detailInfo.id,print_tpl_id:this.print_tpl_id},res=>{
                         this.tip('模板已更改',"success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            getTableDelete(id,row){
                this.del([id],row);
            },
            getTableSee(id){
                this.pl(id);
            },
            getTableEdit(id){
                this.rowClick({
                    id: id,
                    name: 'id',
                    // row: row
                });
            },
            getTransfer(id){
                sessionStorage.setItem("FINISHED_PRODUCT_ORDER_ID",id)
                this.$root.$children[0].$children[0].addTab({
                    name: '板材调货管理'+id,
                    label: '板材调货管理',
                    content: 'purchaseCondimentsList'
                });
            },
        },
        components:{
            tabletem,
            pagination,
            selectDownCustomer,
            saleBillBase,
            saleCheckout
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },


            "businessRelation":function(val){
                if(!val){
                    this.businessRelationForm = this.$cloneJson(initBusinessRelationForm);
                }else{
                    if(this.$refs['feeOutForm']){
                        this.$refs['feeOutForm'].clearValidate()
                    }
                }
            },
            "centerDialogVisible":function(val){
                if(!val){
                    this.refuse_remark="";
                }
            },
            dialogVisible:function (val) {
                if (!val) {
                    this.detailInfo = {};
                    this.newFee = [];
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    .REC_FORM_ITEM /deep/ .el-form-item__content{
        position: relative;
    }
    .taxDiv /deep/ {
        .taxCheck{
            z-index: 11;
        }
        .taxTypeSelect{
            width: 40px;
            position: absolute;
            left: 20px;
            top: 1px;
            z-index: 9;
            .el-input__inner{
                padding-right: 0;
                padding-left: 5px;
                font-size: 14px;
                border-right: none;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
            .el-select__caret{
                font-size: 10px;
                position: relative;
                left: 10px;
            }
        }
        .taxInput{
            position: absolute;
            top: 0;
            padding-left: 60px;
            .el-input__inner{
                padding-left: 10px;
                padding-right: 15px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
        .taxSpan{
            position: absolute;
            right: 3px;
            top: 1px;
            color: red;
        }
    }

    .confirmCheckBox /deep/ .el-checkbox__input{
        position: relative;
        top: -10px;
    }
    .confirmCheckBox /deep/ .el-checkbox__label{
        display: inline-block;
        width: 320px;
        white-space: pre-wrap;
        text-align: left;
    }
    .transferConfirmCheckBox /deep/ .el-checkbox__input{
        position: relative;
        // top: -10px;
    }
    .transferConfirmCheckBox /deep/ .el-checkbox__label{
        display: inline-block;
        width: 320px;
        white-space: pre-wrap;
        text-align: left;
    }
    .cDiaC /deep/ .confirmSpan{
        text-align: left;
        display: block;
    }
    .cDiaC /deep/ .el-dialog__body{
        padding: 20px;
    }
    .cDiaC /deep/ .dialogBtnList{
        padding: 20px 10px 0 10px;
    }
    .cDiaC /deep/ .dialogBtnList .funcPublicBtn,.cDiaC /deep/ .dialogBtnList .publicBtn{
        line-height: 25px;
        padding: 0 10px;
        width: 80px;
    }
    .cDiaC /deep/ .el-dialog__header{
        text-align: left;
    }
    .cDiaC /deep/ .el-dialog__header .el-dialog__title{
        font-size: 15px;
        font-weight: unset;
    }
    .el-icon-more{position: absolute;right:0;cursor: pointer;top:2px;}

    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .bottom_flex{padding-right: 12px; padding-bottom: 8px;}
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
</style>
